import Limit from '@/dto/limits/Limit'

export default function LimitFactory(): Limit {
  return {
    id: null,
    currency: null,
    limit: null,
    countryId: null,
  }
}
